<ng-container *transloco="let t;">
  <p-dialog [header]="title" [(visible)]="visible" [style]="{width: '380px'}" [draggable]="false" [modal]="true" [closable]="false">
    <form (submit)="onSubmit()">
      <div class="p-mb-4">
        <p [innerHTML]="t('template_inherit_dialog.inherit')"></p>
        <p *ngIf="mode === 'template'" [innerHTML]="t('template_inherit_dialog.message_for_template')"></p>
        <p *ngIf="mode === 'exercise'" [innerHTML]="t('template_inherit_dialog.message_for_exercise')"></p>
        <p *ngIf="timing === true" [innerHTML]="t('template_inherit_dialog.timing')"></p>
        <p>
          <app-form-control [cid]="'include'" [control]="form.get('include')" [type]="'checkbox'" [label]="t('template_inherit_dialog.include')"></app-form-control>
        </p>
      </div>
      <div class="p-text-right">
        <button pButton (click)="onCancel()" type="button" label="{{ t('common.labels.cancel') }}" class="p-button-outlined p-button-secondary p-mr-2"></button>
        <button pButton type="submit" label="{{ t('common.ok') }}" class="p-button-success" autofocus></button>
      </div>
    </form>
  </p-dialog>
</ng-container>
